/** @typedef {import("../../../api/types").Order} Order */
import React, {useState} from "react";
import {Button} from "reactstrap";
import {orderPublicLink} from "../utils/orderLink";
import IconLabel from "../../../shared/components/IconLabel";
import {CheckIcon, CopyIcon} from "../../../shared/components/icons";

/**
 * Copies the customer's link to the order. Shows nothing for an order without
 * one. Other props go to the button.
 * @param {{order: Pick<Order, "link_token">, label?: string} & Record<string, any>} props
 */
const CopyLinkButton = ({order, label = "Copiar link", ...buttonProps}) => {
    const link = orderPublicLink(order);
    const [copied, setCopied] = useState(false);

    if (!link) return null;

    const copy = async () => {
        try {
            await navigator.clipboard.writeText(link);
            setCopied(true);
        } catch {
            // Blocked by the browser: nothing to fall back on, and the button stays as it was.
        }
    };

    return (
        <Button {...buttonProps} onClick={copy}>
            {copied ? (
                <IconLabel icon={<CheckIcon />}>Copiado!</IconLabel>
            ) : (
                <IconLabel icon={<CopyIcon />}>{label}</IconLabel>
            )}
        </Button>
    );
};

export default CopyLinkButton;
